<template minapp='mpx' xlang='wxml'>
<view >
    <view class="card-container" wx:for="{{processingOrderList}}" wx:key="index" wx:for-item="order">
        <!-- 占座中状态UI换新 -->
        <view wx:if="{{!order.isAllChanged}}" class="train-information-new-card" wx:class="{{order.isAllGray && 'gray'}}">
          <view style="z-index:1;position:relative">
            <train-information-new 
              trainInfo="{{order}}" 
              isTransfer="{{isTransfer}}"
              showDate="{{hasSeat}}" 
              checkIn="{{getCheckIn(order)}}"
              bind:click="showStayInfo(order)"
              showRecommend
            >
              <block slot="footerSlot">
                <train-order-information-ticket order="{{order}}" hasSeat="{{hasSeat}}" bind:refresh="refresh"/>
              </block>
            </train-information-new>
          </view>
        </view>
    </view>
</view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { innerRouter, pagePath } from "@/common/jump"
  import { OrderStatus, TicketStatus } from '@/common/enum'
  import { formatDate, parseDate } from '@/utils/baseDate'
  import { cloneDeep } from 'lodash'
  import { compareNow, showBtns, showChangeBtn, showRefundBtn } from '@/common/order'

  createComponent({
    props: { orderList: [], from: String, isChange: Boolean, isTransfer: {
      type: Boolean,
      value: false
    } },
    data: {
      selectTicket: '',
      grayStatusName: ['已取消','已改签','已退票'],
      grayStatus: [5,6,7,9,11]
    },
    computed: {
      ...store.mapState({
        baseInfo: 'order.base_info',
        state: 'order.base_info.status', // 订单状态
      }),
      hasSeat(){
        const flag1 = [OrderStatus.OCCUPYING_SEAT].includes(this.state) && this.order_type === 0
        const exemptionNoseatArr = [OrderStatus.ISSUING,OrderStatus.BOOKING,OrderStatus.CLOSED,OrderStatus.REISSUE,OrderStatus.PAID]
        const flag2 = (exemptionNoseatArr.includes(this.state)) && this.order_type === 1
        const flag3 = this.baseInfo.status_name === '占座失败'
        return !(flag1 || flag2 || flag3)
      },
      order_type(){
        return this.baseInfo.order_type
      },
      occupying(){
        return [OrderStatus.OCCUPYING_SEAT].includes(this.state) && this.order_type === 0
      },
      occupy(){
        return [OrderStatus.OCCUPYING_SEAT,OrderStatus.ISSUING].includes(this.state) && this.order_type === 0
      },
      allTickets() {
        const allTickets = {}
        this.orderList?.forEach(({ tickets_info }) => {
          tickets_info?.forEach(({ ticket_id, start_time }) => {
            allTickets[ticket_id] = {
              start_time: parseDate(start_time).getTime()
            }
          })
        })
        return allTickets
      },
      processingOrderList() {
        return this.orderList?.map((order) => {
          const origin_tickets_info = order?.tickets_info?.map((ticket) => {
            const isRefunded = ticket.status.name === '已退票' || ticket.status === 11
            const isChanged = ticket.status_name === '已改签' || ticket.status === 9
            const isGray =
              this.grayStatusName.includes(ticket.status_name) ||
              this.grayStatus.includes(ticket.status)
            const newChange = ticket.pre_ticket_id && (ticket.status_name === '已出票' || ticket.status === 4)
            const waitingPay = ticket.status_name === '待支付' || ticket.status === 2
            const isChanging = ticket.status_name === '改签中' || ticket.status === 8
            const isRefunding = ticket.status_name === '退票中' || ticket.status === 10
            const canChange = showChangeBtn(ticket) && this.baseInfo.order_type !== 1
            const canRefund = showRefundBtn(ticket, this.allTickets) && this.baseInfo.order_type !== 1
            const showStatus = waitingPay || isRefunding || isChanging || canChange || canRefund || newChange || isRefunded
            return { ...ticket, isRefunded, isChanged, newChange, isGray, waitingPay, canChange, canRefund, isChanging, isRefunding, showStatus }
          }).filter(ticket => !ticket.isChanged)
          const isAllChanged = origin_tickets_info?.length === 0
          const isAllGray = this.isAllGray(order)
          const tickets_info = cloneDeep(origin_tickets_info?.slice(0, 1) ?? [])
          const all_tickets_info = cloneDeep(origin_tickets_info ?? [])
          const hideNum = (all_tickets_info?.length ?? 0) - (tickets_info?.length ?? 0)
          return { ...order, tickets_info, isAllChanged, all_tickets_info, isAllGray, hideNum }
        })
      }
    },
    methods: {
      showStayInfo(order) {
        this.triggerEvent('click', order)
      },
      isAllGray(order) {
        return order?.tickets_info?.every(ticket => this.grayStatusName.includes(ticket.status_name) || this.grayStatus.includes(ticket.status)) 
      },
      isAllChanged(order) {
        return order?.tickets_info?.every(ticket => ticket.status_name === '已改签' || ticket.status === 9)
      },
      getCheckIn(order) {
        return order?.tickets_info?.[0]?.check_in || 'default'
      },
      refresh() {
        this.triggerEvent('refresh')
      }
    }
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .es-user-order-information
    box-sizing border-box
    padding 16px 12px
    background #ffffff
    display flex
    justify-content space-between
    border-bottom 1px #F0F1F4 solid
    .custom-class
      width 100%
    /deep/ .label-class
      width 100%
      margin-left 0 !important
    .label-class
      width 100%
      margin-left 0 !important
      display flex
      justify-content space-between
    .es-user-order-info
      display flex
      width 100%
      justify-content space-between
    .es-user-order-info-left
      display flex
      flex-direction column
    .es-user-order-info-left
      text-align left
      .order-info-seat, .order-info-username
        font-size 16px
        font-weight 600
        line-height 22px
        &.noSeat
          margin-top 2px
        &.hasSeat
          margin-top 6px
      .order-info-id
        margin-top 4px
        font-size 14px
        font-weight 400
        line-height 20px
        color $train-color-666
      .order-info-beside-window, .order-info-silent
        display inline-block
        border 1px solid #0d50b2
        border-radius 2px
        font-size 10px
        font-weight 400
        height 14px
        line-height 16px
        color #0d50b2
        transform scale(0.9)
        text-align center
        margin-left 4px
      .order-info-beside-window
        width 24px
      .order-info-silent
        width 14px
    .es-user-order-info-right
      display flex
      flex-direction column
      text-align right
      justify-content space-between
      min-width 105px
      align-items flex-end
      .order-info-price
        font-size 16px
        font-weight normal
        font-family PingFangSC-Medium
        color $train-color-theme-blue
      .order-info-state, .order-info-tip, .order-info-ticket-check
        font-size 12px
        font-weight 400
        line-height 14px
        display flex
        flex-direction row
        align-self flex-end
        color $train-color-666
      .order-info-ticket-operate
        display flex
        align-items center
        .btn
          display flex
          align-items center
          padding 5px 8px
          background-color #F0F1F4
          border-radius 4px
          color #333
          font-family PingFangSC-Regular
          font-size 12px
          font-weight normal
          letter-spacing 0px
          &+.btn
            margin-left 8px
  .train-information-new-card
    padding 0px 12px 12px
    background #FFFFFF
    margin 0 -12px
  .card-container
    &:last-child
      margin-bottom 10px
.gray
  opacity 0.6
	
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'train-information-new': '@/components/train-information-new',
      'train-information-card': '@/pages/order/components/train-information-card/index',
      'train-order-information-passenger': '@/pages/order/components/train-order-information-passenger/index',
      'train-order-information-ticket':'@/pages/order/components/train-order-information-ticket/index',
      'train-information': '@/components/train-information',
      'es-radio': '@didi/es-mpx-ui/lib/radio',
      'es-radio-group': '@didi/es-mpx-ui/lib/radio-group'
    }
  }
</script>